import React from 'react';

import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';

import { useBiopharmaGroupState } from './BiopharmaGroupContext';

const BiopharmaGroupTitle = () => {
  const biopharmaGroupState = useBiopharmaGroupState();

  return (
    <PageTitle text={biopharmaGroupState?.biopharmaGroup?.name || ''} />
  );
};

export default BiopharmaGroupTitle;
